import './Login.css';
import NavBar from '../../components/NavBar/NavBar';
import LoginSection from '../../components/LoginSection/LoginSection';
import Footer from '../../components/Footer/Footer';

const Login = () => {

    const isLoggedIn = localStorage.getItem("sessionId");

    return (
        <>
            {isLoggedIn ?
                <>
                    <NavBar />
                    <div className="already-logged-in-warning-wrapper">
                        <h1>( ≥ o ≤ )</h1>
                        <h1 className="already-logged-in-warning">Kamu sudah login.</h1>
                    </div>
                    <Footer />
                </>
                :
                <>
                    <NavBar />
                    <LoginSection />
                    <Footer />
                </>
            }
        </>
    )
};

export default Login;